import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { get } from 'lodash';

import {
  Container, Form, PlanoDeFundo, Logo,
} from './styled';
import * as actions from '../../store/modules/auth/actions';
import Loading from '../../components/Loading';
import MaskedInput from '../../components/MaskedInputs';
import logo from '../../img/logo.svg';

export default function Login(props) {
  const dispath = useDispatch();

  const prevPath = get(props, 'location.state.prevPath', '/');

  const isLoading = useSelector((state) => state.auth.isLoading);

  const [cpf, setCpf] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    let formErrors = false;

    if (cpf.length !== 14) {
      formErrors = true;
      toast.error('CPF inválido.');
    }

    if (password.length < 6 || password.length > 50) {
      formErrors = true;
      toast.error('Senha inválida');
    }

    if (formErrors) return;

    dispath(actions.loginRequest({ cpf, password, prevPath }));
  };

  return (
    <PlanoDeFundo>
      <Container>
        <Loading isLoading={isLoading} />

        <Logo>
          <img src={logo} alt="" />
        </Logo>

        <h1>Login</h1>

        <Form onSubmit={(e) => (handleSubmit(e))}>

          <MaskedInput
            value={cpf}
            onChange={(e) => setCpf(e.target.value)}
          />
          <input
            type="password"
            value={password}
            autoComplete="false"
            onChange={(e) => setPassword(e.target.value)}
            placeholder="&#xf023;  Senha"
            style={{ fontFamily: 'FontAwesome' }}
          />
          <button type="submit">Acessar</button>
        </Form>
      </Container>
    </PlanoDeFundo>
  );
}
